import { createSelector } from 'reselect';
const getMediaQueryListDSL = (mediaQueryListDSL) => {
    return mediaQueryListDSL;
};
export const getMediaQueryArrayDSL = createSelector(getMediaQueryListDSL, mediaQueryListDSL => Object.values(mediaQueryListDSL));
